import React from 'react';
import { get } from 'lodash';
import { Icon, Loader } from '../components/index';
import Avatar from '../assets/images/pic.png';

import Cookie from 'js-cookie';
import { useHistory, Link } from 'react-router-dom';
import { useAction, useSelect }  from '../hooks';

const UserNavigation = () => {

  const profile = useSelect('auth.profile')
  const gettingProfile = useSelect('loading.isLoading', { type: 'auth.getProfile' })
  const logout = useAction('auth.logout')
  const hisotry = useHistory();
  const onSignOut = e => {
    e.preventDefault()
    logout()
    Cookie.remove('token');
    hisotry.push('/');
  }

  return (
    <>
      <div className="user-navigation space-x-2">
        {!gettingProfile && <img alt="Avatar" src={get(profile, 'attributes.photo') || Avatar} className="w-10 h-10 rounded-full"/>}
        {!gettingProfile && <span>{`${get(profile, 'attributes.first_name')} ${get(profile, 'attributes.last_name')}`}</span>}
        {gettingProfile && <div className="w-32"><Loader.User /></div>}
        
        <Icon.ChevronDown />
        <ul className="options">
          <li className="item space-x-2"><Link to="/profile" className="inline-flex space-x-2 items-center" type="button"><Icon.User/><span className="label">Profile</span></Link></li>
          <li className="item space-x-2"><button onClick={onSignOut} className="inline-flex space-x-2 items-center" type="button"><Icon.SignOut/><span className="label">Sign Out</span></button></li>
        </ul>
      </div>
    </>
  )
}

export default UserNavigation